import styled from "styled-components";

export const AddImageWrapperEl = styled.div`
	position: fixed;
	top: 50px;
	width: 400px;
	left: calc(50% - 250px);
	min-height: 200px;
	border: 1px solid var(--bg-l3);
	background: #f9f9fb;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	border-radius: 3px;
	padding-bottom: 25px;
	z-index: 9999;
	&.collapsed {
		min-height: unset;
		height: auto;
		padding-bottom: 0px;
	}

	// ----------------------
	// ----- CANCEL BTN -----
	// ----------------------
	& .cancel-btn {
		height: 2em;
		width: 2em;
		line-height: 1;
		padding: 0.5em;
		position: absolute;
		top: 5px;
		right: 10px;
		background: rgba(240, 63, 77, 0.15);
		text-align: center;
		border-radius: 3em;
		transition: background 0.05s;
	}

	& .cancel-btn:hover {
		cursor: pointer;
		background: var(--red);
	}

	& .cancel-btn:hover > span {
		color: white;
	}

	& .cancel-btn span {
		font-size: 14px;
		font-weight: 700;
		color: var(--red);
	}
	// ----------------------
	// ----- Collapse BTN -----
	// ----------------------
	& .collapse_toggle {
		height: 2em;
		width: 2em;
		line-height: 1;
		padding: 0.5em;
		position: absolute;
		top: 5px;
		left: 10px;
		background: rgba(149, 155, 171, 0.8);
		text-align: center;
		border-radius: 3em;
		transition: background 0.05s;
	}

	& .collapse_toggle:hover {
		cursor: pointer;
		background: rgba(197, 195, 196, 0.8);
	}

	& .collapse_toggle:hover > span {
		color: rgba(105, 100, 103, 0.8);
	}

	& .collapse_toggle span {
		font-size: 14px;
		font-weight: 700;
		color: black;
	}

	// ---------------------
	// ----- TOP TITLE -----
	// ---------------------
	& .title-wrapper {
		display: block;
		margin-bottom: 20px;
		padding-right: 60px;
	}

	& .title-wrapper h1 {
		text-align: center;
		color: var(--txt-d);
		font-size: 18px;
		margin-top: 22px;
	}
	// ---------------------
	// ----- Header -----
	// ---------------------
	& .header {
		display: flex;
		align-items: center;
		padding: 10px 15px;
	}

	& .header .collapse_toggle {
		position: static;
	}

	& .header .title-wrapper {
		flex: 1;
		margin-bottom: 0;
		padding-right: 25px;

		h1 {
			margin-top: 0;
		}
	}
	// ---------------------
	// --- Image Wrapper ---
	// ---------------------
	& .image-uploader-wrapper {
		/* width: 33.33333%; */
		width: 100%;
		margin: 10px 0;
		padding: 10px 10px 0 10px;
		text-align: center;
	}
	& .image-uploader-wrapper .upload-wrapper {
		position: relative;
		display: inline-block;
		vertical-align: top;
		.dropzone {
			padding: 1em;
		}
	}
	& .image-uploader-wrapper .upload-wrapper .processing-wrapper {
		height: 100%;
		width: 100%;
		text-align: center;
		background: rgba(244, 128, 36, 0.1);
		border: 1px solid rgba(244, 128, 36, 0.45);
		border-radius: 3px;
		position: relative;
		padding: 0;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	& .image-uploader-wrapper .upload-wrapper .processing-wrapper p {
		text-align: center;
		font-size: 12px;
		color: white;
		background: rgba(0, 0, 0, 0.9);
		font-weight: 500;
		position: relative;
		z-index: 2;
		padding: 0 12px;
		height: 24px;
		border-radius: 12px;
	}
	& .image-uploader-wrapper .upload-wrapper .processing-wrapper img {
		position: absolute;
		bottom: 0;
		left: 0;
		max-height: 100%;
		max-width: 100%;
		z-index: 1;
	}
	& .image-uploader-wrapper .upload-wrapper .dz-container {
		background: var(--bg-d1);
		border: 1px dashed var(--bg-d0-dash);
		border-radius: 3px;
		min-height: 100px;
		min-width: 100px;
	}
	& .image-uploader-wrapper .upload-wrapper .dz-container:hover {
		border: 1px dashed var(--blue) !important;
	}
	& .image-uploader-wrapper .upload-wrapper .dz-container p {
		text-align: center;
		font-size: 12px;
	}
	& .image-uploader-wrapper .upload-wrapper .dz-container p.warning {
		color: var(--txt-lg);
	}
	& .image-uploader-wrapper .upload-wrapper .dropzone:hover {
		cursor: pointer;
	}
	& .image-uploader-wrapper .images-wrapper {
		display: inline-block;
		vertical-align: top;
		min-height: 100px;
		margin-left: 10px;
		text-align: center;
	}
	& .image-uploader-wrapper .images-wrapper.reader {
		width: 100%;
		margin-left: 0;
	}
	& .image-uploader-wrapper .images-wrapper .formv-image {
		width: 110px;
		height: 110px;
		position: relative;
		display: inline-block;
		vertical-align: top;
		background: var(--bg-d1);
		border: 1px solid var(--bg-d0-dash);
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 3px;
		overflow: hidden;
	}
	& .image-uploader-wrapper .images-wrapper .formv-image .formv-image-inner {
		height: 100%;
		width: 100%;
		padding: 0;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	& .image-uploader-wrapper .images-wrapper .formv-image img {
		max-width: 100%;
		max-height: 100%;
	}
	& .image-uploader-wrapper .images-wrapper .formv-image:hover {
		cursor: pointer;
		border: 1px solid var(--blue);
	}

	// -----------------------
	// ----- FORM FIELDS -----
	// -----------------------
	& .field-wrapper {
		color: var(--txt-d);
		margin-top: 20px;
		display: block;
		position: relative;
		padding: 0 24px;
	}

	& .field-wrapper label {
		display: block;
		font-size: 13px;
		margin-bottom: 2px;
	}

	& .field-wrapper p {
		display: block;
		font-size: 13px;
		margin-bottom: 10px;
		color: var(--txt-dg);
	}

	& .field-wrapper input {
		display: block;
		font-size: 14px;
		padding: 0.5em;
		margin-bottom: 15px;
		width: 100%;
		border-radius: 3px;
		border: 1px solid var(--bg-l3);
		background: white;
		color: black;
		box-sizing: border-box;
	}

	& .field-wrapper input.valid {
		border: 1px solid var(--green);
		background: rgba(31, 198, 105, 0.1) !important;
	}

	// ----------------------
	// ----- Preview List -----
	// ----------------------
	& .preview-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
		gap: 10px;
		padding: 10px 24px;

		.preview-item {
			position: relative;
			border: 1px solid var(--bg-l3);
			border-radius: 3px;
			overflow: hidden;

			img {
				width: 100%;
				height: 80px;
				object-fit: cover;
				display: block;
			}

			input {
				margin-bottom: 0px;
				display: block;
				width: 100%;
				font-size: 11px;
				padding: 4px 6px;
				border: none;
				border-top: 1px solid var(--bg-l3);
				background: transparent;
				color: var(--txt-dg);
				outline: none;
				box-sizing: border-box;

				&:focus {
					background: white;
					color: var(--txt-d);
				}
			}

			button {
				position: absolute;
				top: 4px;
				right: 4px;
				width: 20px;
				height: 20px;
				border: none;
				border-radius: 50%;
				background: var(--red);
				color: white;
				font-size: 12px;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				line-height: 1;
				opacity: 0;
				transition: opacity 0.2s;
			}

			&:hover button {
				opacity: 1;
			}
		}
	}
	// ----------------------
	// ----- SUBMIT BTN -----
	// ----------------------
	& .submit-btn {
		font-size: 1.25em;
	}

	& .error-wrapper {
		width: 100%;
		padding: 0 20px;
	}
`;